/* eslint-disable no-nested-ternary */
import React from "react";

import { useHistory } from "react-router-dom";

import moment from "moment";
import { Dialog } from "primereact";

import { FilterModel } from "../../../../../domain/models/enum";

import BackButtom from "../../../../components/backButton";
import DataGrid, { ItemField } from "../../../../components/datagrid";
import Icons from "../../../../components/icons-helper";
import ButtonRound from "../../../../components/button-action";
import FormFactory from "../../../../components/form-factory";
import { Fields } from "./fields";

import {
  CardWrapper,
  Wrapper,
  ConfirmDialogStyled,
} from "./styles";
import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "../../companies/list/styles";

import {
  SolicitationProps,
  SolicitationResponseModel,
} from "../../../../../domain/models/solicitation.model";
import { PackageProps } from "../../../../../domain/models/package.model";
import { StackModel } from "../../../../../domain/models/stacks";

import { makeRemoteSolicitation } from "../../../../../main/factories/usecases/solicitation/remote-solicitation-factory";

import toastUtils from "../../../../../utils/ToastUtils";
import { typeRequest } from "../../../../../utils";
import { HelperResendEmailLogin } from "../../../../helpers/help-resend-email-login";
import { Link } from "../../../../components/cards/navigate-card/styles";
import Icon from "../../../../components/icon";

type PageProps = {
  list: SolicitationResponseModel | undefined;
  setParams: any;
  // params: any
  loading?: boolean;
  handleReload: () => void;
  stackList: StackModel[] | undefined;
  packageList: PackageProps[] | undefined;
};

const SolicitationListPage: React.FC<PageProps> = ({
  list,
  setParams,
  loading,
  stackList,
  packageList,
  handleReload,
}) => {
  const history = useHistory();

  const [showInfo, setShowInfo] = React.useState<
    SolicitationProps | undefined
  >();
  const [visible, setVisible] = React.useState<SolicitationProps | undefined>();
  const [remove, setRemove] = React.useState<SolicitationProps | undefined>();
  const [sendEmailLogin, setSendEmailLogin] = React.useState<SolicitationProps | undefined>();

  const fields: ItemField[] = [
    {
      title: "ID",
      key: "id",
      renderItem: (data: SolicitationProps) =>
        data.id.toString().padStart(3, "0"),
    },
    {
      title: "Data Cadastro",
      key: "createdAt",
      renderItem: (data: SolicitationProps) =>
        moment(data.createdAt).format("DD/MM/YYYY"),
    },
    {
      title: "Nome do solicitante",
      key: "nameRequested",
      renderItem: (data: SolicitationProps) =>
        data?.developer?.name?.toString() ||
        data?.developerCompany?.developer?.name?.toString(),
    },
    {
      title: "Plano",
      key: "packageEnum",
      renderItem: (data: SolicitationProps) =>
        data?.developerPackage?.pack?.packageEnum.toString() ||
        "-",
    },
    {
      title: "Telefone",
      key: "name",
      renderItem: (data: SolicitationProps) =>
        data?.developer?.phone &&
        `${data?.developer?.phone?.ddd}${data?.developer?.phone?.number}`,
    },
    {
      title: "Tipo de Solicitação",
      key: "name",
      renderItem: (data: SolicitationProps) =>
        data?.type && typeRequest.find((el) => el.ENUM === data.type)?.label,
    },
    {
      title: "Ações",
      key: "actions",
      renderItem: (data) => (
        <ContainerButtonActions>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => history.push(`/admin/solicitation/edit/${data?.id}`)}
            title="Editar"
            color={theme.colors.lightBlue}
          >
            <Icons
              height={15}
              width={15}
              name="edit"
              color={theme.colors.primary}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => setShowInfo(data)}
            title="Ver"
            color={theme.colors.lightBlue}
          >
            <Icons
              height={15}
              width={15}
              name="eye"
              color={theme.colors.lightBlue}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => {
              setVisible(data);
            }}
            title="Liberar"
            color={theme.colors.lightBlue}
          >
            <Icons
              height={15}
              width={15}
              name="check"
              color={theme.colors.primary}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => {
              setSendEmailLogin(data);
            }}
            title="Enviar email"
            color={theme.colors.lightBlue}
            minWidth="150px"
          >
            <Icons
              height={15}
              width={15}
              name="send-email"
              color={theme.colors.primary}
            />
          </ButtonRound>
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            onClick={() => {
              setRemove(data);
            }}
            title="Excluir"
            color={theme.colors.red}
          >
            <Icons
              height={15}
              width={15}
              name="trash"
              color={theme.colors.red}
            />
          </ButtonRound>
        </ContainerButtonActions>
      ),
    },
  ];
  const onHide = (): void => {
    setShowInfo(undefined);
  };
  const handlePage = (e: any): void => {
    setParams((prev: FilterModel) => ({
      ...prev,
      page: e,
    }));
  };

  return (
    <Wrapper>
      <BackButtom text="Listagem de Novas solicitações" />
      <CardWrapper>
        <Link to="/admin/solicitation/new" invertColor={false} style={{ maxWidth: 200 }}>
          Nova empresa <Icon name="arrow-right" />
        </Link>
      </CardWrapper>
      <DataGrid
        loading={!!loading}
        fields={fields}
        data={list?.content || []}
        totalPages={list?.totalPages || 0}
        changePage={handlePage}
      />
      <ConfirmDialogStyled
        visible={!!visible}
        onHide={() => setVisible(undefined)}
        message="Você confirma a liberação do cadastro do usuário?"
        // header="Confirmation"
        className="confirm-custom-dialog"
        acceptLabel="Sim"
        rejectLabel="Não"
        accept={async () => {
          try {
            await makeRemoteSolicitation().complete(visible?.id);
            handleReload();
            toastUtils.showMessage({
              type: "success",
              message: "Confirmado com Sucesso!",
            });
          } catch (error: any) {
            toastUtils.showMessage({
              type: "error",
              message: error?.userMessage || error?.detail,
            });
          }
        }}
        reject={() => setVisible(undefined)}
      />
      <ConfirmDialogStyled
        visible={!!remove}
        onHide={() => setRemove(undefined)}
        message="Você confirma a exclusão dessa solicitação?"
        // header="Confirmation"
        className="confirm-custom-dialog"
        acceptLabel="Sim"
        rejectLabel="Não"
        accept={async () => {
          try {
            await makeRemoteSolicitation().delete(remove?.id as number);
            handleReload();
            toastUtils.showMessage({
              type: "success",
              message: "Excluído com Sucesso!",
            });
          } catch (error: any) {
            toastUtils.showMessage({
              type: "error",
              message: error?.userMessage || error?.detail,
            });
          }
        }}
        reject={() => setRemove(undefined)}
      />

      <ConfirmDialogStyled
        visible={!!sendEmailLogin}
        onHide={() => setSendEmailLogin(undefined)}
        message="Você confirma o envio de novas credenciais por email?"
        // header="Confirmation"
        className="confirm-custom-dialog"
        acceptLabel="Sim"
        rejectLabel="Não"
        accept={async () => {
          try {
            const response = await HelperResendEmailLogin.resendEmailLogin(sendEmailLogin?.developer?.id);
            handleReload();
            if (response === true) {
              toastUtils.showMessage({
                type: "success",
                message: "Email enviado com sucesso!",
              });
            } else {
              toastUtils.showMessage({
                type: "error",
                message: "Não foi possível enviar o email"
              });
            }

          } catch (error: any) {
            toastUtils.showMessage({
              type: "error",
              message: error?.userMessage || error?.detail,
            });
          }
        }}
        reject={() => setSendEmailLogin(undefined)}
      />

      <Dialog
        header={showInfo?.id?.toString().padStart(3, "0")}
        visible={!!showInfo}
        style={{ width: "70vw" }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        footer={null}
        onHide={() => onHide()}
      >
        <FormFactory
          groups={Fields(showInfo, stackList, packageList)}
          enbaleCountGroup
          onSubmit={async (values, actions) => {
            try {
              console.warn(values);
              actions.setSubmitting(false);
            } catch (error) {
              actions.setSubmitting(false);
            }
          }}
          backButton={{
            submit: "Voltar",
            submitting: "Voltando...",
            hide: true,
            onClick: () => history.goBack(),
          }}
          button={{
            submit: "Salvar",
            submitting: "Salvando...",
            hide: true,
            backgroundColor: theme.colors.darkBlue,
          }}
        />
      </Dialog>
    </Wrapper>
  );
};
export default SolicitationListPage;
